
class WhatsAppConst {
  
    static Interakt = 1;
    static AiSensy = 2;
    static Wati = 3;
    static DoubleTick = 4;
    static DevSoft = 9;
  
    static Options = [
        {
            value: WhatsAppConst.AiSensy,
            label: ( <>
                <span style={{ paddingRight: "5px" }}>AiSensy</span>
                <img src="/images/third-party/aisensy.png" width="20" height="20" alt="AiSensy"/>
            </>)
        },
        {
            value: WhatsAppConst.DoubleTick,
            label: ( <>
                <span style={{ paddingRight: "5px" }}>Double Tick</span>
                <img src="/images/third-party/double_tick.png" width="20" height="20" alt="Double Tick"/>
            </>)
        },
        {
            value: WhatsAppConst.Interakt,
            label: ( <>
                <span style={{ paddingRight: "5px" }}>interakt.ai</span>
                <img src="/images/third-party/interakt.png" width="20" height="20" alt="interakt"/>
            </>)
        },
        {
            value: WhatsAppConst.Wati,
            label: ( <>
                <span style={{ paddingRight: "5px" }}>Wati</span>
                <img src="/images/third-party/wati.svg" width="20" height="20" alt="Wati"/>
            </>)
        },
        {
            value: WhatsAppConst.DevSoft,
            label: ( <>
                <span style={{ paddingRight: "5px" }}>Dev Soft</span>
                <img src="/images/third-party/dave_soft.png" width="20" height="20" alt="Dev Soft"/>
            </>)
        }
    ];
  }
  
  export default WhatsAppConst;